import * as React from "react";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkText } from "uitk-react-text";
import { useLocalization } from "@shared-ui/localization-context";

export interface BeachproximityProps {
  name: string;
  walkTime: number;
  drivingTime: number;
}

export const BeachProximity: React.FC<BeachproximityProps> = (props) => {
  if (!props.name && !props.walkTime && !props.drivingTime) {
    return null;
  }

  const BEACH_FRONT_WALKING_TIME = 1;
  const MAX_WALKING_TIME = 20;
  const MAX_DRIVING_TIME = 20;

  const { formatText } = useLocalization();

  if (props.drivingTime > MAX_DRIVING_TIME) {
    return null;
  }

  const distanceText = React.useMemo(() => {
    switch (true) {
      case props.walkTime <= BEACH_FRONT_WALKING_TIME:
        return <UitkText size={300}>{formatText("hotels.affinity.distanceToBeach.beachFront", props.name)}</UitkText>;
      case props.walkTime > BEACH_FRONT_WALKING_TIME && props.walkTime <= MAX_WALKING_TIME:
        return (
          <UitkText size={300}>
            {formatText("hotels.affinity.distanceToBeach.walkingDistance.other", props.name, props.walkTime)}
          </UitkText>
        );
      case props.walkTime > MAX_WALKING_TIME && props.drivingTime <= MAX_DRIVING_TIME:
        const drivingDistance =
          props.drivingTime === 1
            ? formatText("hotels.affinity.distanceToBeach.drivingDistance.one", props.name)
            : formatText("hotels.affinity.distanceToBeach.drivingDistance.other", props.name, props.drivingTime);

        return <UitkText size={300}>{drivingDistance}</UitkText>;
      default:
        return null;
    }
  }, []);

  return (
    <UitkLayoutFlex
      space="two"
      wrap={"nowrap"}
      alignItems={"center"}
      className="uitk-cell all-t-padding-four beachProximity"
    >
      <UitkLayoutFlexItem>
        <UitkIcon name="beach_access" size={UitkIconSize.SMALL} />
      </UitkLayoutFlexItem>
      <UitkLayoutFlexItem>{distanceText}</UitkLayoutFlexItem>
    </UitkLayoutFlex>
  );
};

export default BeachProximity;
